import { request } from './client';

export interface WbsLabels {
  wbs1: string;
  wbs1Plural: string;
  wbs2: string;
  wbs2Plural: string;
  wbs3: string;
  wbs3Plural: string;
}

export interface BillingCategoryItem {
  category: number;
  description: string;
}

export interface LaborCodeItem {
  code: string;
  lcLevel: number;
  label: string;
}

export interface TimesheetSettings {
  showLaborCode: string;
  // VP ChangeDefaultLC — 'Y' when the user may change their labor code, else it
  // is locked to the default. Distinct from showLaborCode (display, not edit).
  changeLaborCode: string;
  showBillCategory: string;
  showWbs1: string;
  showWbs2: string;
  showWbs3: string;
  // VP's Firm Name column switch: 'Y' / 'N', or '' when VP leaves it unset (shown).
  showFirmName?: string;
  requireComments: string;
  // VP increment code: 'Q' = quarter-hour (0.25), 'H' = half-hour (0.5), 'T' = tenth (0.1),
  // 'W' = whole-hour (1.0). Anything else falls back to 0.25 in the composable.
  increment: string;
  wbs1Length: number;
  wbs2Length: number;
  wbs3Length: number;
  lcLevels: number;
  billingCategories: BillingCategoryItem[];
  laborCodes: LaborCodeItem[];
  wbsLabels: WbsLabels;
  // New in C8 — default labor code / billing category for the tenant.
  defaultLaborCode?: string;
  defaultLaborCodeName?: string;
  defaultBillingCategory?: number;
  defaultBillingCategoryName?: string;
  // Company fields — shown in AppHeader when multiCompanyEnabled.
  company?: string;
  companyName?: string;
  multiCompanyEnabled?: boolean;
  // ISO date of the current period end (null when VP has no current period set).
  currentPeriodEnd?: string | null;
}

export function getTimesheetSettings(): Promise<TimesheetSettings> {
  return request<TimesheetSettings>('/api/timesheet/settings');
}
